import { combineReducers, configureStore } from '@reduxjs/toolkit'
import accountSlice from 'features/account/accountSlice'
import dialogSlice from 'features/dialog/dialogSlice'
import toastSlice from 'features/toast/toastSlice'
import progressBarSlice from 'features/ad/progressBar/progressBarSlice'
import campaignSlice from 'features/ad/campaign/campaignSlice'
import adGroupSlice from 'features/ad/group/adGroupSlice'
import keywordSlice from 'features/ad/keyword/keywordSlice'
import groupCreativeSlice from 'features/ad/creative/groupCreativeSlice'
import restrictionIpListSlice from 'features/restrictionIp/restrictionIpListSlice'
import restrictionIpAddSlice from 'features/restrictionIp/restrictionIpAddSlice'
import restrictionIpUpdateSlice from 'features/restrictionIp/restrictionIpUpdateSlice'
import channelListSlice from 'features/channel/list/channelListSlice'
import channelAddSlice from 'features/channel/add/channelAddSlice'
import trackerListSlice from 'features/crux/tracker/list/trackerListSlice'
import createTrackSlice from 'features/crux/tracker/modal/create/createTrackSlice'
import kakaoServiceTrackSlice from 'features/crux/tracker/modal/kakaoService/kakaoServiceTrackSlice'
import requestTrackSlice from 'features/crux/tracker/modal/request/requestTrackSlice'
import talkChannelRegisterSlice from 'features/talkChannelRegister/talkChannelRegisterSlice'
import documentListSlice from 'features/document/documentListSlice'
import documentAddSlice from 'features/document/documentAddSlice'
import creativeListSlice from 'features/creative/list/creativeListSlice'
import creativeListFilterSlice from 'features/creative/list/creativeListFilterSlice'
import creativeAddSlice from 'features/creative/add/creativeAddSlice'
import buildCreativeSlice from 'features/creative/add/build/buildCreativeSlice'
import additionalLinkSlice from 'features/creative/add/asset/additionalLinkSlice'
import additionalTitleSlice from 'features/creative/add/asset/additionalTitleSlice'
import calculateSlice from 'features/creative/add/asset/calculateSlice'
import priceTableSlice from 'features/creative/add/asset/priceTableSlice'
import thumbnailSlice from 'features/creative/add/asset/thumbnailSlice'
import multiThumbnailSlice from 'features/creative/add/asset/multiThumbnailSlice'
import subjectSlice from 'features/creative/add/asset/subjectSlice'
import talkChannelSlice from 'features/creative/add/asset/talkChannelSlice'
import phoneNumberSlice from 'features/creative/add/asset/phoneNumberSlice'
import basicCreativeSlice from 'features/creative/add/basic/basicCreativeSlice'
import creativeImportSlice from 'features/creative/add/import/creativeImportSlice'
import reportListSlice from 'features/report/reportListSlice'
import reportAddSlice from 'features/report/reportAddSlice'
import imageLibrarySlice from 'features/image/imageLibrarySlice'
import imageListSlice from 'features/image/imageListSlice'
import proposalKeywordSlice from 'features/keywordPlanner/proposalKeywordSlice'
import predictKeywordSlice from 'features/keywordPlanner/predictKeywordSlice'
import addKeywordsSlice from 'features/keywordPlanner/addKeywordsSlice'
import editlogSlice from 'features/editlog/editlogSlice'
import downloadSlice from 'features/bulk/download/downloadSlice'
import downloadModalSlice from 'features/bulk/download/downloadModalSlice'
import uploadSlice from 'features/bulk/upload/uploadSlice'
import uploadModalSlice from 'features/bulk/upload/uploadModalSlice'
import adGroupCopyHistorySlice from 'features/bulk/adGroupCopy/adGroupCopyHistorySlice'
import keywordUploadSlice from 'features/bulk/keywordPlanner/keywordUploadSlice'
import keywordUploadModalSlice from 'features/bulk/keywordPlanner/keywordUploadModalSlice'
import trackerDetailSlice from 'features/crux/tracker/detail/trackerDetailSlice'
import backDropSlice from 'features/dialog/backDropSlice'
import lnbSlice from 'features/lnb/lnbSlice'
import dashboardCommonSlice from 'features/dashboard/dashboardCommonSlice'
import campaignTableSlice from 'features/dashboard/table/campaign/campaignTableSlice'
import adGroupTableSlice from 'features/dashboard/table/adGroup/adGroupTableSlice'
import keywordTableSlice from 'features/dashboard/table/keyword/keywordTableSlice'
import creativeTableSlice from 'features/dashboard/table/creative/creativeTableSlice'
import dashboardOnOffSlice from 'features/dashboard/operation/onOff/onOffSlice'
import dashboardDeleteSlice from 'features/dashboard/operation/delete/deleteSlice'
import campaignConversionTrackingEditSlice from 'features/dashboard/operation/campaignConversionTrackingEdit/campaignConversionTrackingEditSlice'
import campaignTraceUrlEditSlice from 'features/dashboard/operation/campaignTraceUrlEdit/campaignTraceUrlEditSlice'
import campaignDailyBudgetEditSlice from 'features/dashboard/operation/campaignDailyBudgetEdit/campaignDailyBudgetEditSlice'
import adGroupMaxBiddingAmountEditSlice from 'features/dashboard/operation/adGroupMaxBiddingAmountEdit/adGroupMaxBiddingAmountEditSlice'
import adGroupContentMatchingMaxBiddingAmountEditSlice from 'features/dashboard/operation/adGroupContentMatchingMaxBiddingAmountEdit/adGroupContentMatchingMaxBiddingAmountEditSlice'
import adGroupWeightEditSlice from 'features/dashboard/operation/adGroupWeightEdit/adGroupWeightEditSlice'
import adGroupDailyBudgetEditSlice from 'features/dashboard/operation/adGroupDailyBudgetEdit/adGroupDailyBudgetEditSlice'
import adGroupPlacementEditSlice from 'features/dashboard/operation/adGroupPlacementEdit/adGroupPlacementEditSlice'
import adGroupDeviceEditSlice from 'features/dashboard/operation/adGroupDeviceEdit/adGroupDeviceEditSlice'
import adGroupDurationEditSlice from 'features/dashboard/operation/adGroupDurationEdit/adGroupDurationEditSlice'
import adGroupWeeklyScheduleEditSlice from 'features/dashboard/operation/adGroupWeeklyScheduleEdit/adGroupWeeklyScheduleEditSlice'
import adGroupKeywordExtensionEditSlice from 'features/dashboard/operation/adGroupKeywordExtensionEdit/adGroupKeywordExtensionEditSlice'
import keywordExposurePreviewSlice from 'features/dashboard/operation/keywordExposurePreview/keywordExposurePreviewSlice'
import dashboardTreeSlice from 'features/dashboard/tree/dashboardTreeSlice'
import dashboardInfoSlice from 'features/dashboard/info/dashboardInfoSlice'
import dashboardChartSlice from 'features/dashboard/info/chart/dashboardChartSlice'
import copyAdGroupsSlice from 'features/dashboard/operation/adGroupCopy/copyAdGroupsSlice'
import keywordBiddingStrategySlice from 'features/dashboard/operation/keywordBiddingStrategyEdit/keywordsBiddingStrategyEditSlice'
import keywordBiddingStrategyEditModalSlice from 'features/dashboard/operation/keywordBiddingStrategyEdit/keywordBiddingStrategyEditModalSlice'
import keywordLandingUrlEditSlice from 'features/dashboard/operation/keywordLandingUrlEdit/keywordLandingUrlEditSlice'
import keywordLandingUrlEditModalSlice from 'features/dashboard/operation/keywordLandingUrlEdit/keywordLandingUrlEditModalSlice'
import creativePreviewSlice from 'features/dashboard/operation/creativePreview/creativePreviewSlice'
import copyKeywordsSlice from 'features/dashboard/operation/keywordCopy/copyKeywordsSlice'
import adGroupSelectSlice from 'features/dashboard/operation/adGorupSelect/adGroupSelectSlice'
import tableConfigSlice from 'features/dashboard/table/config/tableConfigSlice'
import dashboardFilterSlice from 'features/dashboard/filter/dashboardFilterSlice'
import thumbnailRecommendSlice from 'features/creative/add/asset/thumbnailRecommendSlice'
import thumbnailCustomSlice from 'features/creative/add/asset/thumbnailCustomSlice'
import reviewReasonSlice from 'features/reviewReason/reviewReasonSlice'
import layoutSlice from 'features/layout/layoutSlice'
import gnbSlice from 'features/gnb/gnbSlice'
import loginSlice from 'features/login/loginSlice'
import { createReduxEnhancer } from '@sentry/react'
import { cruxApi } from '../api/rtk-query/cruxApi'
import { setupListeners } from '@reduxjs/toolkit/query'
import { loungeBoardApi } from '../api/rtk-query/loungeBoardApi'

const reducer = {
  layout: layoutSlice,
  gnb: gnbSlice,
  login: loginSlice,
  account: accountSlice,
  lnb: lnbSlice,
  dialog: dialogSlice,
  toast: toastSlice,
  backDrop: backDropSlice,
  dashboard: combineReducers({
    common: dashboardCommonSlice,
    tree: dashboardTreeSlice,
    info: dashboardInfoSlice,
    chart: dashboardChartSlice,
    filter: dashboardFilterSlice,
    table: combineReducers({
      config: tableConfigSlice,
      campaignTable: campaignTableSlice,
      adGroupTable: adGroupTableSlice,
      keywordTable: keywordTableSlice,
      creativeTable: creativeTableSlice,
    }),
    operation: combineReducers({
      onOff: dashboardOnOffSlice,
      delete: dashboardDeleteSlice,
      campaignConversionTrackingEdit: campaignConversionTrackingEditSlice,
      campaignTraceUrlEdit: campaignTraceUrlEditSlice,
      campaignDailyBudgetEdit: campaignDailyBudgetEditSlice,
      adGroupMaxBiddingAmountEdit: adGroupMaxBiddingAmountEditSlice,
      adGroupContentMatchingMaxBiddingAmountEdit:
        adGroupContentMatchingMaxBiddingAmountEditSlice,
      adGroupWeightEdit: adGroupWeightEditSlice,
      adGroupDailyBudgetEdit: adGroupDailyBudgetEditSlice,
      adGroupPlacementEdit: adGroupPlacementEditSlice,
      adGroupDeviceEdit: adGroupDeviceEditSlice,
      adGroupDurationEdit: adGroupDurationEditSlice,
      adGroupWeeklyScheduleEdit: adGroupWeeklyScheduleEditSlice,
      adGroupKeywordExtensionEdit: adGroupKeywordExtensionEditSlice,
      adGroupSelect: adGroupSelectSlice,
      keywordBiddingStrategy: keywordBiddingStrategySlice,
      keywordBiddingStrategyEditModal: keywordBiddingStrategyEditModalSlice,
      keywordLandingURL: keywordLandingUrlEditSlice,
      keywordLandingUrlEditModal: keywordLandingUrlEditModalSlice,
      keywordExposurePreview: keywordExposurePreviewSlice,
      creativePreview: creativePreviewSlice,
      copyAdGroups: copyAdGroupsSlice,
      copyKeywords: copyKeywordsSlice,
    }),
  }),
  ad: combineReducers({
    progressBar: progressBarSlice,
    campaign: campaignSlice,
    adGroup: adGroupSlice,
    keyword: keywordSlice,
    groupCreative: groupCreativeSlice,
  }),
  restrictionIp: combineReducers({
    restrictionIpList: restrictionIpListSlice,
    restrictionIpAdd: restrictionIpAddSlice,
    restrictionIpUpdate: restrictionIpUpdateSlice,
  }),
  channel: combineReducers({
    channelList: channelListSlice,
    channelAdd: channelAddSlice,
  }),
  tracker: combineReducers({
    trackerList: trackerListSlice,
    createTrack: createTrackSlice,
    kakaoServiceTrack: kakaoServiceTrackSlice,
    requestTrack: requestTrackSlice,
    detail: trackerDetailSlice,
  }),
  talkChannelRegister: talkChannelRegisterSlice,
  document: combineReducers({
    documentList: documentListSlice,
    documentAdd: documentAddSlice,
  }),
  creative: combineReducers({
    creativeList: creativeListSlice,
    creativeListFilter: creativeListFilterSlice,
    creativeAdd: creativeAddSlice,
    buildCreative: buildCreativeSlice,
    assets: combineReducers({
      additionalLink: additionalLinkSlice,
      additionalTitle: additionalTitleSlice,
      calculate: calculateSlice,
      priceTable: priceTableSlice,
      thumbnail: thumbnailSlice,
      multiThumbnail: multiThumbnailSlice,
      subject: subjectSlice,
      talkChannel: talkChannelSlice,
      phoneNumber: phoneNumberSlice,
      thumbnailRecommend: thumbnailRecommendSlice,
      thumbnailCustom: thumbnailCustomSlice,
    }),
    basicCreative: basicCreativeSlice,
    creativeImport: creativeImportSlice,
  }),
  report: combineReducers({
    reportList: reportListSlice,
    reportAdd: reportAddSlice,
  }),
  image: combineReducers({
    imageLibrary: imageLibrarySlice,
    imageList: imageListSlice,
  }),
  keywordPlanner: combineReducers({
    proposalKeyword: proposalKeywordSlice,
    predictKeyword: predictKeywordSlice,
    addKeywords: addKeywordsSlice,
  }),
  editlog: editlogSlice,
  bulk: combineReducers({
    download: downloadSlice,
    downloadModal: downloadModalSlice,
    upload: uploadSlice,
    uploadModal: uploadModalSlice,
    adGroupCopy: adGroupCopyHistorySlice,
    keywordUpload: keywordUploadSlice,
    keywordUploadModal: keywordUploadModalSlice,
  }),
  reviewReason: reviewReasonSlice,
  [cruxApi.reducerPath]: cruxApi.reducer,
  [loungeBoardApi.reducerPath]: loungeBoardApi.reducer,
}
const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware(),
    cruxApi.middleware,
    loungeBoardApi.middleware,
  ],
  enhancers: defaultEnhancers => [...defaultEnhancers, createReduxEnhancer()],
  devTools: {
    name: 'FOKA',
  },
})
setupListeners(store.dispatch)
export default store
